// extracted by mini-css-extract-plugin
export default {"toast":"uoJHJ4","neutral":"I_mRGr","negative":"tIXZ0J","positive":"hNPKvJ"};